var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:['switcher', 'switcher--'+_vm.items.length]},_vm._l((_vm.items),function(item,index){return _c('div',{key:index,class:['switcher__item', _vm.activeItem==item.code?'--active':''],on:{"click":function($event){return _vm.changeActiveItem(item.code)}}},[_vm._v(" "+_vm._s(item.name)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }